import React, { useState } from 'react';
import './styles.scss';

interface VideoPlayerProps {
  videoSrc: string; // URL of the video to play
  coverImage?: string; // URL of the cover image
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoSrc, coverImage }) => {
  const [isCoverVisible, setIsCoverVisible] = useState(true);

  const handleVideoPlay = () => {
    setIsCoverVisible(false); // Hide the cover image
  };

  return (
    <div className="video-player mt-5 govuk-bp:mt-0 w-full">
      {isCoverVisible && (
        <div
          className="video-player__thumbnail nhsuk-card nhsuk-card--clickable overflow-hidden cursor-pointer w-full"
          onClick={handleVideoPlay}
          onKeyDown={handleVideoPlay}
        >
          <img
            className="nhsuk-card__img video-player__image"
            src={coverImage}
            alt=""
          />
        </div>
      )}
      {!isCoverVisible && (
        <div className="w-full" style={{ aspectRatio: '16 / 9' }}>
          <iframe
            width="100%"
            height="100%"
            src={`${videoSrc}?autoplay=1&mute=1&cc_load_policy=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      )}
    </div>
  );
};

VideoPlayer.defaultProps = {
  coverImage: '',
};

export default VideoPlayer;
